<mat-card *ngIf="dataExchangeService.painting.assessmentInfo">

    <mat-card-content>
        <p>{{'Degree' | translate}}: {{dataExchangeService?.painting.assessmentInfo.burnDegree}}°</p>
    </mat-card-content>

</mat-card>
